import { ref, watch } from 'vue'

const lang = ref(localStorage.getItem('lang') || 'fa')

const dir = ref(lang.value === 'fa' ? 'rtl' : 'ltr')

watch(lang, (val) => {
  localStorage.setItem('lang', val)
  dir.value = val === 'fa' ? 'rtl' : 'ltr'
})

watch(dir, (val) => {
  document.documentElement.setAttribute('dir', val)
  document.documentElement.setAttribute('lang', lang.value)
})

const setLang = (val) => {
  lang.value = val
}

export { lang, setLang }
